var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCrossIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1221 0.605225C16.8921 -0.186319 18.1584 -0.203675 18.9502 0.566162C19.7417 1.33615 19.759 2.60247 18.9893 3.39429L12.5664 9.99976L18.9883 16.6052C19.7581 17.3971 19.7408 18.6633 18.9492 19.4333C18.1574 20.2032 16.8911 20.1859 16.1211 19.3943L9.77734 12.8689L3.43359 19.3943C2.66362 20.1858 1.39732 20.2031 0.605469 19.4333C-0.186121 18.6633 -0.203447 17.3971 0.566406 16.6052L6.9873 9.99976L0.56543 3.39429C-0.204438 2.60243 -0.187142 1.33617 0.604492 0.566162C1.39635 -0.203705 2.66261 -0.186409 3.43262 0.605225L9.77734 7.13062L16.1221 0.605225Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCrossIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cross-icon.1e280515bf617a1e0cf434bceae53c86.svg";